import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton, FlexStack } from '~/components/atomic';
import { FullScreenLoading } from '~/components/common';
import { useCreateChatRoomMutation } from '~/features/chatRoom';
import { PAGE_ROUTE } from '~/constants';
import SuccessImage from '~/assets/img/completion_images/girls_smiling_and_waving.png';
import { useUserStore } from '~/store';
import useCreateNewCharacterStore from '~/store/useCreateNewCharacterStore';

export default function StepComplete() {
  const navigate = useNavigate();
  const { language } = useUserStore((state) => ({
    email: state.email,
    language: state.language,
  }));
  const finalGenerateState = useCreateNewCharacterStore(
    (state) => state.finalGenerateState,
  );

  const { mutate: createChatRoomMutate, isPending } =
    useCreateChatRoomMutation();

  const handleChatClick = () => {
    if (isPending) return;

    createChatRoomMutate(
      {
        character_id: finalGenerateState.characterId,
        language,
      },
      {
        onSuccess({ data, status }, request) {
          navigate(`${PAGE_ROUTE.CHAT}/${data.chatroom_id}`);
        },
      },
    );
  };

  if (finalGenerateState.type === 'user') {
    return (
      <Container>
        <FlexStack
          css={css`
            text-align: center;
          `}
        >
          <Title>Thank you for submitting!</Title>
          <Description>
            It will take a few days to complete the process.
            <br />
            We'll notify you once it's done!
          </Description>
        </FlexStack>

        <BottomButtonWrapper>
          <DefaultButton onClick={() => navigate(PAGE_ROUTE.MAIN)}>
            Go to home
          </DefaultButton>
        </BottomButtonWrapper>
      </Container>
    );
  }

  if (
    finalGenerateState.type === 'preset' ||
    finalGenerateState.type === 'avaturn'
  ) {
    return (
      <>
        {isPending && <FullScreenLoading />}
        <Container>
          <FlexStack
            css={css`
              align-items: center;
              justify-content: center;
            `}
          >
            <div
              css={css`
                img {
                  display: block;
                  width: auto;
                  max-width: 100%;
                  max-height: 275px;
                }
              `}
            >
              <img src={SuccessImage} alt='success' />
            </div>
            <DescBox>
              <strong>Complete</strong>
              <p>Your character is here</p>
            </DescBox>
          </FlexStack>

          <BottomButtonWrapper>
            <DefaultButton onClick={handleChatClick}>Chat now</DefaultButton>
            <DefaultButton
              colorType='black'
              onClick={() => navigate(PAGE_ROUTE.MAIN)}
            >
              Go to home
            </DefaultButton>
          </BottomButtonWrapper>
        </Container>
      </>
    );
  }

  return null;
}
const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.title.section24_bold};
  `}
`;

const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

const StyledFlexStack = styled(FlexStack)`
  align-items: center;
`;

const BottomButtonWrapper = styled(FlexStack)`
  position: absolute;
  bottom: 40px;
  width: 100%;
  padding: 16px;
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    text-align: center;

    strong {
      display: block;
      width: 100%;
      ${theme.fontStyle.title.section24_bold}
      color: ${theme.content.content_light_1};
    }

    p {
      display: block;
      width: 100%;
      color: ${theme.content.content_light_3};
      ${theme.fontStyle.text.body16_medium}
    }
  `}
`;
